import { memo, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Row, Col } from 'antd';

import Price from '../../atoms/price';

import { makerCoinCode, removePreSuffix } from '../../../utils/common';
import { exchangeColor } from '../../../constant/color';

import { addFavorite, removeFavorite } from '../../../store/modules/favorite';

import ThemeContext from '../../../context/theme';

interface Props {
}

const Favorite = (props: any) => {

}

const Compare = (props: Props) => {
  const theme = useContext(ThemeContext);
  const { upbit, cobit, bithumb, favoriteMap = {} } = useSelector((state: any) => ({
    upbit: state.upbit,
    bithumb: state.bithumb,
    cobit: state.cobit,
    favoriteMap: state.favorite.map
  }))

  const { selectCoin = '' } = useSelector((state: any) => ({
    selectCoin: state.coin.select
  }))
  const dispatch = useDispatch();

  const coinName: { [key: string]: string } = makerCoinCode(selectCoin);
  
  const upbitPrice = upbit.data[upbit.m[coinName.upbit]]?.close
  const bitumbPrice = bithumb.data[bithumb.m[coinName.bithumb]]?.close
  const cobitPrice = cobit.data[cobit.m[coinName.cobit]]?.close

  const list = [{
    name: '업비트',
    color: exchangeColor.upbit,
    price: upbitPrice
  }, {
    name: '빗썸',
    color: exchangeColor.bithumb,
    price: bitumbPrice
  }, {
    name: '코빗',
    color: exchangeColor.cobit,
    price: cobitPrice
    }].sort((a: any, b: any) => b.price - a.price)
  
  const coinSymbol = removePreSuffix(selectCoin).toUpperCase()
  
  const addFavoriteHandler = (e: any) => {
    if (!coinName.default) return
    dispatch(addFavorite({coin: coinName.default}));
  }
  const removeFavoriteHandler = (e: any) => {
    if (!coinName.default) return
    dispatch(removeFavorite({coin: coinName.default}));
  }
  // console.log(favoriteMap, coinName.default)
  const favorite = favoriteMap[coinName.default] >= 0 ? (
    <i className="fas fa-heart fa-2x" onClick={removeFavoriteHandler} style={{color: 'red'}}/>
    ) : (
    <i className="far fa-heart fa-2x" onClick={addFavoriteHandler} style={{color: 'red'}}/>
  )
  return (
    <Card
      title={`선택코인 비교 ${coinSymbol}`}
      extra={favorite}
      style={{
        width: "100%", backgroundColor: theme.background.default,
      }}
      headStyle={{ borderBottomColor: theme.borderColor.default, color: theme.color.default }}
      bordered={false}
    >
      <Row>
        <Col span={12}>
          <h5 style={{ margin: 0,  color: theme.color.default}}>시세순위</h5>
          {list.map((item: any, idx: number) => (
            <p style={{ color: item.color, margin: 0 }}>
              [{idx + 1}]: {item.name}
              <br />{"=> "}
              <Price value={item.price} suffix={coinSymbol} />
            </p>
          ))}
        </Col>

        <Col span={12}>
          <h5 style={{margin: 0,  color: theme.color.default}}>시세차이</h5>
          <p style={{margin: 0,  color: theme.color.default}}>
            업비트 - 빗썸 
            <br /> {"=> "} 
            <Price value={upbitPrice - bitumbPrice} suffix={coinSymbol}/>
          </p>
          <p style={{margin: 0,  color: theme.color.default}}>
            업비트 - 코빗 
            <br /> {"=> "} 
            <Price value={upbitPrice - cobitPrice} suffix={coinSymbol}/>
          </p>
          <p style={{margin: 0,  color: theme.color.default}}>
            빗썸 - 코빗
            <br /> {"=> "} 
            <Price value={bitumbPrice- cobitPrice} suffix={coinSymbol}/>
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default memo(Compare);
